export interface DynamicForm {
  form: FormElement[]
}

export interface FormElement {
  id: string
  name: string
  sections: FormSection[]
}

export interface FormSection {
  name: string
  fields: FormField[]
}

export enum FormFieldType {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  DATE = "DATE",
  SELECT = "SELECT",
}

export interface FormField {
  input_name: string
  input_type: FormFieldType
  input_key: string
  required: boolean
  parent?: {
    input_key: string
    input_value: string
  }
  options?: FormOption[]
  input_regex?: RegExp
  error_prompt?: string
}

export interface FormOption {
  label: string
  value: string
}
